export default class AccountingDocumentNumber {
    constructor(pointOfSale, number) {
        this._pointOfSale = pointOfSale;
        this._number = number;
    }

    shortened() {
        // The ERP pads points of sale to 5 digits and numbers to 8, but no document with a point of sale
        // uses more than 2 and 6 significant digits. Documents without one (certificates, adjustments) use all 8.
        const POINT_OF_SALE_DIGITS = 2;
        const NUMBER_DIGITS = 6;
        if (!this._pointOfSale) {
            return this._number;
        }
        return `${this._shortenedDigits(this._pointOfSale, POINT_OF_SALE_DIGITS)}-${this._shortenedDigits(this._number, NUMBER_DIGITS)}`;
    }

    _shortenedDigits(zeroPaddedDigits, digits) {
        return zeroPaddedDigits.replace(/^0+/, '').padStart(digits, '0');
    }
}
